export const clientsZoom2Data = [
  {
    id: "2620:0:862:ed1a::1",
    type: "default",
    position: { x: 555, y: 130 },
    className: "PC",
    data: { label: "2620:0:862:ed1a::1" },
    dragHandle: "noDrag",
  },
  {
    id: "77.75.79.138",
    type: "default",
    position: { x: 120, y: 70 },
    className: "notebook",
    data: { label: "77.75.79.138" },
    dragHandle: "noDrag",
  },
  {
    id: "195.113.27.221",
    type: "default",
    position: { x: 750, y: 60 },
    className: "mobil",
    data: { label: "195.113.27.221" },
    dragHandle: "noDrag",
  },
  {
    id: "185.158.64.12",
    type: "default",
    position: { x: 700, y: 450 },
    className: "mobil",
    data: { label: "185.158.64.12" },
    dragHandle: "noDrag",
  },

  {
    id: "172.16.0.1",
    type: "default",
    position: { x: 590, y: 550 },
    className: "PC",
    data: { label: "172.16.0.1" },
    dragHandle: "noDrag",
  },
];
